import { createApi } from '@reduxjs/toolkit/query/react';

import { IApplicationContext } from '../types/ICustomContextParams';
import { fetchGetSpecialistsCatalog } from '../repositories/demand/v2/get-specialists-catalog';
import { IGeoExV4Schema } from '../repositories/demand/entities/geo/GeoExV4Schema';
import { REALTORS_ON_PAGE } from '../constants/pagination';
import { IGetSpecialistsCatalogResponseV2 } from '../repositories/demand/entities/specialist_catalog/GetSpecialistsCatalogResponseV2';
import { createBaseQuery } from './utils/createBaseQuery';

export type TSpecialistsApiEndpoints = keyof typeof specialistsApi.endpoints;
export let specialistsApi: ReturnType<typeof createSpecialistsApi>;

export const createSpecialistsApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'specialistsApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getSpecialists: builder.query<
        IGetSpecialistsCatalogResponseV2,
        {
          geo: IGeoExV4Schema;
          pageNumber?: number;
        }
      >({
        query: rawParameters => {
          const { geo, pageNumber = 1 } = rawParameters;
          const parameters = {
            geo,
            limit: REALTORS_ON_PAGE,
            offset: (pageNumber - 1) * REALTORS_ON_PAGE,
          };

          return {
            parameters,
            fetchFunction: fetchGetSpecialistsCatalog,
            loggerInfo: {
              description: 'Получение списка риелторов',
              // TODO: падение этой ручки блокирует флоу, но, кажется, не должно этого происходить
              degradation: 'Критическая ошибка. Видит экран "Произошла ошибка"',
            },
          };
        },
      }),
    }),
  });

  specialistsApi = newApi;

  return newApi;
};
